import React from 'react'
import Chip from '@mui/material/Chip'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { getBaseLocationLabel } from './globalRosterUtils'

const RosterStatusStrip = ({ roster }) => {
  if (!roster) return null

  return (
    <Paper variant="outlined" sx={{ p: 1.25, borderRadius: 2 }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        justifyContent="space-between"
        gap={1}
      >
        <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
          <Chip
            size="small"
            label={roster.title}
            variant="outlined"
            sx={{ borderRadius: 1, fontWeight: 700 }}
          />
          <Chip
            size="small"
            color={roster.status === 'Published' ? 'success' : 'info'}
            label={roster.status}
            sx={{ borderRadius: 1, fontWeight: 700 }}
          />
          {roster.isOnCall && (
            <Chip
              size="small"
              color="warning"
              variant="outlined"
              label="On Call"
              sx={{ borderRadius: 1, fontWeight: 700, borderStyle: 'dashed' }}
            />
          )}
          {getBaseLocationLabel(roster.baseLocation) && (
            <Chip
              size="small"
              label={getBaseLocationLabel(roster.baseLocation)}
              variant="outlined"
              sx={{ borderRadius: 1 }}
            />
          )}
        </Stack>
        <Typography variant="body2" color="text.secondary">
          {roster.isOnCall
            ? 'On-call rota plan: Manager and Supervisor teams only, shift conflicts are advisory.'
            : roster.status === 'Published'
              ? 'Published rota plan: its shifts are live on the roster and can be edited individually.'
              : 'Draft rota plan: shifts only go live once you publish.'}
        </Typography>
      </Stack>
    </Paper>
  )
}

export default RosterStatusStrip
